var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4498",
    "data-name": "Group 4498",
    transform: "translate(-1401 -247)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4827",
    "data-name": "Rectangle 4827",
    width: 35,
    height: 35,
    rx: 5,
    transform: "translate(1401 247)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4104",
    "data-name": "Group 4104",
    transform: "translate(-17.5 -54.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5298",
    "data-name": "Path 5298",
    d: "M145.275,38.006a.931.931,0,0,0,1.317,0l3.512-3.512a.931.931,0,0,0-1.317-1.317L146.865,35.1V24.931a.931.931,0,0,0-1.862,0V35.1l-1.922-1.922a.931.931,0,0,0-1.317,1.317Z",
    transform: "translate(1290.066 285.83)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5299",
    "data-name": "Path 5299",
    d: "M41.073,232a.931.931,0,0,0-.931.931v7.139H25.862v-7.139a.931.931,0,0,0-1.862,0v7.45a1.552,1.552,0,0,0,1.552,1.552h14.9A1.552,1.552,0,0,0,42,240.381v-7.45A.931.931,0,0,0,41.073,232Z",
    transform: "translate(1402.998 85.901)",
    fill: "#176eb5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload2);
export default __webpack_public_path__ + "static/media/download2.a77383acc4cdf9df19782b2b2cbedbf9.svg";
export { ForwardRef as ReactComponent };